// Shared MUI `sx` for outlined inputs / selects so the social-media-connect
// modals match the "Manage > My Account" form 1:1.
// Mirrors the sx + className applied in components/Administration.js.

export const formInputSx = {
  backgroundColor: 'white',
  borderRadius: '8px',
  '& .MuiOutlinedInput-root.Mui-focused': {
    '& fieldset': {
      border: '1px solid #515151',
    },
  },
  '& .MuiInputLabel-root': {
    color: 'gray',
    fontSize: '14px',
    fontWeight: 500,
    '&.Mui-focused': {
      color: '#5616ea',
    },
  },
};
